import { render, staticRenderFns } from "./set-campus.vue?vue&type=template&id=5bbfc7ba&"
import script from "./set-campus.vue?vue&type=script&lang=js&"
export * from "./set-campus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports